/*
 * Narutieum Monitor
 * Copyright (c) 2026 Narutieum
 * Licensed under GPLv3.
 * License guide: https://narutieum.com/bbs/content.php?co_id=naru_license
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
